import { Global } from '../../utils/global';
import { SpecialtyRepository } from '../contracts/repositories';
import { Specialty } from '../entities';

interface LocalStorageSpecialties {
  data: Specialty[];
  expiresIn: number;
}

export class SpecialtyService {
  constructor(private readonly specialtyRepository: SpecialtyRepository) {}

  async listSpecialties(): Promise<Specialty[]> {
    let specialties = this.getSpecialtiesFromLocalStorage();
    if (specialties) return specialties;

    specialties = await this.specialtyRepository.findAll();
    this.saveSpecialtiesInLocalStorage(specialties);

    return specialties;
  }

  async getOne(code: string): Promise<Specialty> {
    const specialties = await this.listSpecialties();
    const specialty = specialties.find((specialty) => specialty.code === code);
    if (!specialty) throw new Error('Specialty not found');

    return specialty;
  }

  private saveSpecialtiesInLocalStorage(specialties: Specialty[]) {
    const OneDayInMilliseconds: number = 60 * 60 * 60 * 24;
    const expiresIn = Date.now() + OneDayInMilliseconds;
    const localStorageSpecialties: LocalStorageSpecialties = {
      data: specialties,
      expiresIn
    };

    window.localStorage.setItem(
      Global.LOCAL_STORAGE_SPECIALTIES,
      JSON.stringify(localStorageSpecialties)
    );
  }

  private getSpecialtiesFromLocalStorage(): Specialty[] | undefined {
    const rawData = window.localStorage.getItem(Global.LOCAL_STORAGE_SPECIALTIES);
    if (!rawData) return;

    const specialtiesData = JSON.parse(rawData) as LocalStorageSpecialties;
    if (specialtiesData.data.length <= 0 || specialtiesData.expiresIn < Date.now()) return;

    return specialtiesData.data;
  }
}
